<template>
	<div class="main-containter" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'发展历程30'"  :activeNames="'关于我们'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">关于我们</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">About Us</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 关于我们</span>
				<span style="color:#333333;font-size:14px;"> / 发展历程</span>
			</div>
			<div style="font-size: 22px;font-weight: 900;color: #AA1100;margin-left: 3%;margin-top:20px;">发展历程</div>
			<div style="color: #AA1100;margin-left: 3%;margin-top: 5px;font-size: 14px;">Development History</div>
			<div style="margin-left: 3%;margin-top: 5px;width: 20px;height: 3px;background: #AA1100;"></div>
			<div style="width: 94%;margin-right: 3%;margin-left: 3%;">
                <img style="width:100%;" src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/pcHistory2.png">
				<!-- <div class="timelineBox">
            <el-timeline ref="timeline">
                <el-timeline-item v-for="(item, index) in versionAnnouncementList" :key="index" color="#CCCCCC">
                    <div v-if="index%2==0" class="evenDiv">
                        <div class="timelinItemBox0">
                            <div class="timelinItemBox-top f-r a-c" :style="{color:index%2==0?'#A6A6A6':'#ffffff','text-align':'right'}">
                                <div>
																	<div style="float: right;width: 40px;height: 0px;border: 1px dashed rgb(204, 204, 204);margin-top: 8px;margin-right: -30px;"></div>
																	<div style="float:right;margin-right:20px">{{item.releaseTime}}</div></div>
                            </div>
                            <div class="timelinItemBox-bottom" :style="{color:index%2==0?'#7F7F7F':'#ffffff','text-align':'right','margin-right': '32px',widht:'100%'}">
                                <div v-for="(item2,index2) in item.list" :key="index2+item2">
																	<div>
																		<span style="width: 4px;display: inline-block;height: 4px;margin-bottom: 3px;margin-right: 7px;background: #7F7F7F;"></span>
																		<span>{{item2}}</span>
																	</div>
																</div>
                            </div>
                        </div>
                        <div class="timelinItemBox1">
                            <div class="timelinItemBox-top f-r a-c">
                                <div>{{item.releaseTime}}</div>
                            </div>
                            <div class="timelinItemBox-bottom">
                                {{item.content}}
                            </div>
                        </div>
                    </div>
                    <div v-else class="unevenDiv">
                        <div class="timelinItemBox0">
                            <div class="timelinItemBox-top f-r a-c">
                                <div>{{item.releaseTime}}</div>
                            </div>
                            <div class="timelinItemBox-bottom">
                                {{item.content}}
                            </div>
                        </div>
                        <div class="timelinItemBox1">
                            <div class="timelinItemBox-top f-r a-c" :style="{color:index%2!=0?'#A6A6A6':'#ffffff','text-align':'left'}">
																<div style="float: left;width: 40px;height: 0px;border: 1px dashed rgb(204, 204, 204);margin-top: 8px;margin-left: -30px;"></div>
                                <div style="float:left;margin-left:20px">{{item.releaseTime}}</div>
                            </div>
                            <div class="timelinItemBox-bottom" :style="{color:index%2!=0?'#A6A6A6':'#ffffff','text-align':'left',widht:'100%','margin-right': '10px'}">
                                <div v-for="(item2,index2) in item.list" :key="index2+item2" style="margin-right: 20px;">
																	<div>
																		<span>{{item2}}</span>
																		<span style="width: 4px;display: inline-block;height: 4px;margin-bottom: 3px;margin-left: 7px;background: #7F7F7F;"></span>
																	</div>
																</div>
                            </div>
                        </div>
                    </div>
                </el-timeline-item>
            </el-timeline>
        </div> -->
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				
				totalWidth:document.documentElement.clientWidth,
				left:46,
				versionAnnouncementList: [
                
                {		
                    uuid: "20230314_1053_5398371131177979",
										list:['上海和华利盛律师事务所成立'],
                    releaseTime: "2001-04-18",
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['多次获著名法律杂志The Asia Pacific Legal 500（亚太法律500强）重点推荐'],
                    releaseTime: "2004年开始",
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer'],
                    content: "测试1234",
                    version: "V3.1",
                    releaseTime: "2023-10-28",
                    createTime: "2023-03-14 10:53:49",
                    updateTime: "2023-03-14 15:01:13",
                    color: '#21A0AD'
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer'],
                    content: "测试1234",
                    version: "V3.1",
                    releaseTime: "2023-10-28",
                    createTime: "2023-03-14 10:53:49",
                    updateTime: "2023-03-14 15:01:13",
                    color: '#507CBE'
                }, 
                {
                    uuid: "20230314_1053_5398371131177979",
										list:['测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer','测试1234查Referer测试1234查Referer'],
                    content: "测试1234",
                    version: "V3.1",
                    releaseTime: "2023-10-28",
                    createTime: "2023-03-14 10:53:49",
                    updateTime: "2023-03-14 15:01:13",
                    color: '#21A0AD'
                },
                
            ],
			}
		},
		mounted() {
			window.onresize = () => {
				return (() => {
					this.totalWidth = document.documentElement.clientWidth
				})()
			}
			this.left = (this.totalWidth/2)-40
			this.changeLeft()
			console.log(this.totalWidth)
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		watch: {
			screenWidth: {
				handler: function (val) {
					this.left = (this.totalWidth/2)-40
					this.changeLeft()
				},
				immediate: true,
				deep:true
			},
		},
		methods: {
			changeLeft(){
				document.getElementsByClassName('timelineBox')[0].style.left=this.left+'px'
				// this.$refs.mycolor.style.setProperty("--bgc",'white');
			}
		}
	}
</script>

<style lang="scss" scoped>
	
// 通用样式 start
.h-100{
    height: 100%;
}
.p-r{
    position: relative;
}
.f-r {
    // display: flex;
    flex-direction: row;
}
.a-c {
    align-content: center;
    align-items: center;
}
.m-l20 {
    margin-left: 20px;
}
// 通用样式 end

.timelineBox {
    position: absolute;
    left: 50%;
    // top:85%;
    // width: 50%;
    .el-timeline-item{
        padding-bottom: 5px;
    }
}
.timelinItemBox0 {
    width: calc(100% - 28px - 2px);
    height: calc(80% - 2px);
    position: absolute;
    right: calc(100% + 18px);
    // border: 1px solid #dedede;
    border-radius: 5px;
}
.timelinItemBox1{
    height: calc(100% - 2px);
    // border: 1px solid #dedede;
    border-radius: 5px;
}
.timelinItemBox-top{
    height: 25px;
    padding: 0 10px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    color: #ffffff;
}
.timelinItemBox-bottom{
    // padding: 10px;
    color: #606266;
    line-height: 20px;
    white-space: pre-wrap;
		width: 100%;
}
.evenDiv{
    .timelinItemBox1{
			height: 180px;
        border: 1px solid #ffffff;
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        .timelinItemBox-bottom{
            color: #ffffff;
        }
    }
}
.unevenDiv{
    .timelinItemBox0{
        border: 1px solid #ffffff;
        -moz-user-select: none;
        -khtml-user-select: none;
        user-select: none;
        .timelinItemBox-bottom{
            color: #ffffff;
        }
    }
}
</style>
